document.addEventListener('Searchanise.Loaded', function () {
  if (window.customerData) {
    console.log('[Snize Overlay] Usuario conectado, overlay desactivado');
    return;
  }

  (function ($) {
    const lang = document.documentElement.lang || '';
    const isFrench = lang.toLowerCase().startsWith('fr') || window.location.pathname.startsWith('/fr');

    const MESSAGE = isFrench ? 'Connectez-vous pour voir les prix des cartouches Compatibles pour HP' : 'Sign in to view prices for compatible HP cartridges';
    const BUTTON = isFrench ? 'Se connecter' : 'Log in';
    const OVERLAY_FLAG = 'data-snize-login-overlay';
    const HIDDEN_FLAG = 'data-snize-compat-hidden';

    function buildLoginUrl() {
      const returnUrl = window.location.pathname + window.location.search + window.location.hash;
      return '/account/login?return_url=' + encodeURIComponent(returnUrl);
    }

    function applyOverlay(card) {
      if (card.hasAttribute(OVERLAY_FLAG)) return;
      card.setAttribute(OVERLAY_FLAG, 'true');

      const childrenToBlur = Array.from(card.children);
      if (childrenToBlur.length === 0) return;

      const wrapper = document.createElement('div');
      wrapper.style.position = 'relative';
      childrenToBlur[0].parentNode.insertBefore(wrapper, childrenToBlur[0]);

      childrenToBlur.forEach(function (child) {
        child.style.filter = 'blur(8px)';
        child.style.pointerEvents = 'none';
        child.style.userSelect = 'none';
        wrapper.appendChild(child);
      });

      const loginUrl = buildLoginUrl();

      // Bloquear cualquier clic dentro de la card original y redirigir al login.
      // Capture phase para interceptar antes de que Snize lo procese.
      card.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        window.location.href = loginUrl;
      }, true);

      const overlay = document.createElement('div');
      overlay.style.cssText = 'position:absolute;inset:0;background:rgba(255,255,255,0.75);display:flex;align-items:center;justify-content:center;border-radius:4px;z-index:10;pointer-events:auto;padding:8px;';
      overlay.innerHTML = '<div style="background:#fff;padding:14px 18px;border-radius:8px;box-shadow:0 4px 14px rgba(0,0,0,0.15);border:1px solid #e5e7eb;text-align:center;max-width:90%;"><p style="font-size:14px;font-weight:600;margin:0 0 10px 0;line-height:1.3;color:#111;">🔒 ' + MESSAGE + '</p><a href="' + loginUrl + '" style="display:inline-block;background:#16a34a;color:#fff;padding:8px 16px;border-radius:4px;text-decoration:none;font-size:13px;font-weight:500;">' + BUTTON + '</a></div>';
      wrapper.appendChild(overlay);
    }

    function hideCard(card) {
      if (card.hasAttribute(HIDDEN_FLAG)) return;
      card.setAttribute(HIDDEN_FLAG, 'true');
      card.style.display = 'none';

      const next = card.nextElementSibling;
      if (next && next.classList.contains('snize-separator')) {
        next.style.display = 'none';
      }
    }

    function analyzeProducts(productos) {
      let totalHP = 0;
      const compatibles = [];

      productos.forEach(function (prod) {
        const tituloEl = prod.querySelector('.snize-title');
        if (!tituloEl) return;
        const titulo = tituloEl.textContent.trim();

        if (/^HP\b/i.test(titulo)) totalHP++;
        else if (/^Compatible\s+HP\b/i.test(titulo)) compatibles.push(prod);
      });

      return { totalHP: totalHP, compatibles: compatibles };
    }

    // Página de resultados completa: regla del 50%, aplica overlay
    $(document).on('Searchanise.ResultsUpdated', function (event, container) {
      const productos = container.find('li.snize-product').toArray();
      if (productos.length === 0) return;

      const result = analyzeProducts(productos);
      if (result.totalHP === 0) return;

      const ratioCompatibles = (result.compatibles.length / result.totalHP) * 100;
      if (ratioCompatibles <= 50) return;

      result.compatibles.forEach(applyOverlay);
      console.log('[Snize Overlay] Resultados: ' + result.compatibles.length + ' compatibles con overlay');
    });

    // Autocomplete dinámico: empujar a originales, oculta los compatibles
    $(document).on('Searchanise.AutocompleteUpdated', function (event, input, container) {
      const productos = container.find('li.snize-product').toArray();
      if (productos.length === 0) return;

      const result = analyzeProducts(productos);
      if (result.totalHP === 0) return;

      result.compatibles.forEach(applyOverlay);
      console.log('[Snize Overlay] Autocomplete: ' + result.compatibles.length + ' compatibles ocultos');
    });

  })(window.Searchanise.$);
});